import {Component, Input} from '@angular/core';
import {DatatableColumn} from '../../model/column/datatable-column';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'nc-date-filter',
  templateUrl: './nc-date-filter.component.html',
  styleUrls: ['./nc-date-filter.component.scss']
})
export class NcDateFilterComponent {
  @Input() formGroup: FormGroup;
  @Input() column: DatatableColumn;

  private DOT_CODE = 46;
  private ZERO_CODE = 48;
  private NINE_CODE = 57;

  dateFormatFilter(event): boolean {
    const code = event.keyCode;
    const isDot = code === this.DOT_CODE;
    const isNumber = code >= this.ZERO_CODE && code <= this.NINE_CODE;
    return isDot || isNumber;
  }
}
